import { fontGroups } from '@zoopla-eng/zds/themes';
import {
    addressStyle,
    descriptionStyle,
    summaryWrapperStyle
} from './summary.styles.css';

type SummaryProps = {
    description: string;
    address: string;
};

const Summary: React.FC<SummaryProps> = ({ description, address }) => (
    <div className={summaryWrapperStyle}>
        <h2
            className={`${descriptionStyle} ${fontGroups.ladle}`}
            data-testid="listing-title"
        >
            {description}
        </h2>
        <h3 className={`${addressStyle} ${fontGroups.fork}`}>{address}</h3>
    </div>
);

export { Summary };
